import { ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigBraveSearchSettings } from "./app-settings-config-brave-search";

export interface IConfigBraveSearchInputState {
  showModal: boolean;
  editingBraveSearchId: string;
}

export interface IConfigBraveSearchInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput?: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigBraveSearchInput extends PureComponent<IConfigBraveSearchInputProps, IConfigBraveSearchInputState> {
  formInputName: string[] = ["apiConfig", "braveSearchSettingsId"];

  constructor(props: IConfigBraveSearchInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingBraveSearchId: ""
    };
  }

  openModal = (): void => {
    this.setState({ showModal: true, editingBraveSearchId: "" });
  };

  closeModal = (): void => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string): void => {
    this.setState({ editingBraveSearchId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render(): ReactNode {
    return (
      <>
        <ConfigBraveSearchSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingBraveSearchId={this.state.editingBraveSearchId}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Brave Search"
          formInputName={this.formInputName}
          options={this.props.commonSettings.braveSearchSettings ?? []}
          allowClear
          tooltipContentKey="appsettings_mcp_bravesearch"
          onAddNew={this.openModal}
          onEdit={this.setEditingSetting}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId="appSettingsMcpBraveSearchDropdown"
          addNewTestId="appSettingsMcpBraveSearchAddNewButton"
          editTestId="appSettingsMcpBraveSearchEditButton"
        />
      </>
    );
  }
}
